export default "__VITE_ASSET__Dqln9ioT__"